import { api } from './api';

export async function registerEvaluate(payload: any): Promise<any> {
  const { data } = await api.post(`database/evaluates__c`, payload);
  return data;
}

export async function getEvaluate(userId: any, contentId: any): Promise<any[]> {
  const payload = [{ $match: { userId: userId, contentId: contentId } }, { $sort: { created: -1 } }, { $limit: 1 }];
  const { data } = await api.post(`database/evaluates__c/aggregate`, payload);

  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function getAverangeRating(contentId: any): Promise<any[]> {
  const payload = [
    { $match: { contentId: contentId } },
    {
      $group: {
        _id: '$contentId',
        averageRating: { $avg: '$rating' },
      },
    },
    {
      $project: {
        _id: 1,
        averageRating: { $round: ['$averageRating', 1] },
      },
    },
  ];
  const { data } = await api.post(`database/evaluates__c/aggregate`, payload);

  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}
